import { useId } from "react";

/* Chaturbate's own mark, the orange "C" from the logo at chaturbate.com (web.static.mmcdn.com/images/logo-new.svg),
   path and gradient as they ship it (Jay, 2026-11-05: actual logos, not generic icons). */

const MARK =
  "M13.657 9.5047C21.4079 9.17526 22.0391 0.172563 16.0152 0.158837C12.8258 0.150993 10.5578 1.75308 8.721 3.9768C8.6818 4.64156 9.52079 5.69654 9.54236 5.724C9.30517 5.53379 7.65853 3.9866 7.58208 3.91601L7.57816 3.91208C5.93545 2.42373 4.4868 1.10205 2.78332 1.6217C0.730913 2.24724 0.264368 4.37487 0.156552 5.38083C0.13891 5.55732 0.342779 5.66321 0.479998 5.54947C1.86983 4.39448 3.85559 5.81812 6.40592 7.26922C5.17094 9.79296 4.56325 13.0285 4.55541 14.8267C4.53385 19.2604 6.37455 23.2999 11.3537 23.6902C16.2367 24.0706 18.4675 19.882 18.2225 16.972C18.0382 14.8071 16.7072 14.1639 16.0368 13.9757C15.8603 13.9266 15.7015 14.0639 15.7015 14.2463C15.6976 16.8759 13.8471 17.9485 12.3063 17.9485C10.15 17.9485 9.28556 16.1837 9.1405 15.8013C8.50733 14.1482 8.89743 11.7284 9.90501 9.76354C9.22675 9.22036 9.11502 8.55168 9.09934 8.52619C9.79916 8.87523 11.287 9.63216 13.655 9.51058V9.50666L13.657 9.5047ZM17.8637 4.90236C18.1852 6.06716 16.8385 6.89272 16.0152 7.16333C14.2568 7.74181 12.4396 7.20255 12.1123 6.89272C12.9336 5.76322 17.2482 2.67865 17.8637 4.90236Z";

export function ChaturbateMark({ size = 15, className }: { size?: number; className?: string }) {
  // Each mark on the page needs its own gradient id, or every copy paints with the first one's.
  const id = `cb-mark-${useId().replace(/:/g, "")}`;
  return (
    <svg width={size} height={size} viewBox="0 0 22 24" className={className} aria-hidden="true" focusable="false">
      <defs>
        <linearGradient id={id} x1="13.1316" y1="32.938" x2="9.70079" y2="0.774818" gradientUnits="userSpaceOnUse">
          <stop offset="0.15" stopColor="#FFB81C" />
          <stop offset="0.79" stopColor="#FF6900" />
        </linearGradient>
      </defs>
      <path d={MARK} fill={`url(#${id})`} />
    </svg>
  );
}

/**
 * The same mark drawn as an outline icon, to sit with the rest of the nav (Tabler's 24px grid, a
 * 1.7 stroke in the text colour). Jay, 2026-11-05: the orange mark stood out from every other icon.
 * Traced from the logo's centre lines: the bowl with its hook, the loop at the top right and the
 * flick at the top left, all meeting where the logo's strokes cross.
 */
export function ChaturbateIcon({ size = 15, stroke = 1.7 }: { size?: number; stroke?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={stroke} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
      <path d="M17.64 14.62C18.12 17.66 16.28 20.22 13.56 20.38C10.52 20.54 8.76 18.14 8.84 15.02C8.92 12.62 9.72 10.46 11.32 8.94" />
      <path d="M11.32 8.94C12.68 7.02 14.68 4.22 17.08 4.06C19.32 3.9 19.96 6.22 18.28 7.82C16.76 9.26 13.72 9.74 11.96 9.26" />
      <path d="M11.32 8.94C9.8 7.26 7.88 5.18 6.2 4.94C5.08 4.78 4.28 5.66 4.04 6.7" />
    </svg>
  );
}
